import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_ENTHOR_DIAS = 'ALL_ENTHOR_DIAS';
export const LOADING_ALL_ENTHOR_DIAS = 'LOADING_ALL_ENTHOR_DIAS';
export const ACTIVO_ENTHOR_DIAS = 'ACTIVO_ENTHOR_DIAS';
export const PARAMS_ENTHOR_DIAS = 'PARAMS_ENTHOR_DIAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const entHorDiasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ENTHOR_DIAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_ENTHOR_DIAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ENTHOR_DIAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ENTHOR_DIAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
